"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRows = void 0;
const react_1 = __importDefault(require("react"));
const row_1 = require("./row");
const TableRows = (props) => {
    const { rows, getTableBodyProps, prepareRow, selectionProps, tableRef, tableModificators, } = props;
    return (react_1.default.createElement("tbody", { ...getTableBodyProps() }, rows.map((row, rowIndex) => {
        prepareRow(row);
        const tableRowProps = {
            rowIndex,
            rowCount: rows.length,
            row,
            selectionProps,
            tableRef,
            tableModificators,
        };
        return (react_1.default.createElement(row_1.TableRow, { ...tableRowProps, key: rowIndex }));
    })));
};
exports.TableRows = TableRows;
//# sourceMappingURL=rows.js.map